import axios from 'axios';

import { buildEndpoint } from '@services/service';

const BASE_URL = process.env.REACT_APP_PAYMENTS_URL as string;

type Response = { id: number; rate: number; currency: string }[];

const getCurrencyExchange = async (token: string): Promise<Response> => {
    try {
        const url = buildEndpoint(BASE_URL, 'api/v2/payments/config');
        const response = await axios.get(url.toString(), {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    } catch (err) {
        console.error('Error getting currency exchange:', err);
        return [];
    }
};

export { getCurrencyExchange };
